// extracted by mini-css-extract-plugin
module.exports = {"delegatePropertModal":"Delegates_delegatePropertModal__23Va0","tableContainer":"Delegates_tableContainer__sxlie"};